import { useEffect, useRef } from 'react';
const useDisconnected = (address, onDisconnected) => {
    const prevAddressRef = useRef(address);
    useEffect(() => {
        if (prevAddressRef.current !== address && !address) {
            onDisconnected?.();
        }
        prevAddressRef.current = address;
    }, [address, onDisconnected]);
};
export default useDisconnected;
//# sourceMappingURL=useDisconnected.js.map